<template>
  <div class="AccreditTest">
    <el-form :inline="true" :model="formScreen" ref="formScreen">
      <el-form-item
        label="选择分公司"
        prop="branchCompany"
        v-if="[1].includes(type)"
      >
        <el-select
          v-model="formScreen.branchCompany"
          placeholder="请选择"
          @change="selectChange($event, 'sonCompany')"
          value-key="company_id"
          filterable
        >
          <el-option
            v-for="item in branchCompany"
            :key="item.company_id"
            :label="item.companyName"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="选择子公司"
        prop="sonCompany"
        v-if="[2, 1].includes(type)"
      >
        <el-select
          v-model="formScreen.sonCompany"
          placeholder="请选择"
          value-key="rid"
          @change="selectChange($event, 'branchDepartmentList')"
          filterable
        >
          <el-option
            v-for="item in sonCompany"
            :key="item.company_id"
            :label="item.companyName"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="选择分部门" prop="branchDepartmentValue">
        <el-select
          v-model="formScreen.branchDepartmentValue"
          placeholder="请选择"
          @change="selectChange($event, 'groupList')"
          value-key="rid"
        >
          <el-option
            v-for="item in branchDepartmentList"
            :key="item.value"
            :label="item.departmentName"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="选择组" prop="groupValue">
        <el-select
          v-model="formScreen.groupValue"
          placeholder="请选择"
          @change="selectChange($event, 'userList')"
          value-key="rid"
        >
          <el-option
            v-for="item in groupList"
            :key="item.value"
            :label="item.groupName"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="选择角色" prop="userValue">
        <el-select
          v-model="formScreen.userValue"
          placeholder="请选择"
          @change="selectChange($event)"
          value-key="rid"
        >
          <el-option
            v-for="item in userList"
            :key="item.value"
            :label="item.roleUserName"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="选择活跃状态" prop="active">
        <el-select v-model="active" clearable placeholder="请选择">
          <el-option label="活跃" :value="1"></el-option>
          <el-option label="下架" :value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="选择店铺状态" prop="state">
				<el-select v-model="state" clearable placeholder="请选择">
					<el-option label="正常" :value="1"></el-option>
					<el-option label="删除" :value="0"></el-option>
				</el-select>
			</el-form-item>
      <el-form-item>
        <el-row>
          <el-input
            v-model="SearchInp"
            placeholder="店铺名称、商户ID"
            style="width: 250px"
          ></el-input>
          <el-button
            type="primary"
            @click="Search2"
            size="mini"
            style="margin-left: 10px; padding: 7px 15px"
            >搜索</el-button
          >
          <el-button
            type="primary"
            @click="formScreenReset"
            size="mini"
            style="padding: 7px 15px"
            >重置</el-button
          >
        </el-row>
      </el-form-item>
    </el-form>
    <el-select v-model="region" placeholder="请选择地域" clearable filterable>
      <el-option label="美国地域" value="US"></el-option>
      <el-option label="非美国地域" value="oauth"></el-option>
    </el-select>
    <el-button type="primary" @click="toAuthUrl" :disabled="!region">授权</el-button>
    <!-- <el-button type="primary" @click="exchange" :loading="exchangeLoading" :disabled="isDisabled"
      >交换令牌</el-button
    > -->
    <!-- <el-button type="primary" @click="AddName = true" :disabled="refreshToken ? false : true">授权店铺</el-button> -->
    <el-button type="primary" @click="toTutorial">TikTok教程</el-button>
    <div id="amazon-root"></div>
    <div class="ymx_in">
      <el-table
        :data="tableData"
        border
        style="width: 100%; margin-bottom: 50px"
        v-loading="loadingTable"
      >
        <!--
          :span-method="spanMethod"
          <el-table-column
          prop="mainAccountId"
          label="主账号ID"
          align="center"
        ></el-table-column> -->
        <el-table-column
          prop="shop_name"
          label="店铺名称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="sellerId"
          label="商户ID"
          align="center"
        ></el-table-column>
        <el-table-column label="授权国家" align="center">
          <template slot-scope="scope">
            <div v-for="item in tableCountry[scope.$index]" :key="item.id">
              {{ item.countryName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="authorization_time"
          label="授权时间"
        ></el-table-column>
        <el-table-column
          prop="active"
          align="center"
          width="150"
          label="活跃状态"
        >
          <template slot-scope="scope">
            
            <el-switch
              v-model="scope.row.active"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="活跃"
              inactive-text="下架"
              :active-value="1"
              :inactive-value="0"
              @change="handleTableSwitch(scope.row)">
            </el-switch>
            
          </template>
        </el-table-column>
        <el-table-column
					align="center"
					prop="state"
					label="店铺状态"
					width="80"
				>
					<template slot-scope="scope">
						<span :class="scope.row.state == 1 ? 'green-text' : 'red-text'">{{ scope.row.state == 1 ? '正常' : '删除' }}</span>
					</template>
				</el-table-column>
        <el-table-column
          align="center"
          prop="operationName"
          label="运营部/角色"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="purchaseName"
          label="采购人员"
        ></el-table-column>
        <el-table-column
          width="200"
          prop="fenName"
          label="所属分公司"
          align="center"
          v-if="type === 1"
        ></el-table-column>
        <el-table-column
          width="200"
          prop="ziName"
          label="所属子公司"
          align="center"
          v-if="[1, 2].includes(type)"
        ></el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="300"
          align="center"
          v-if="type === 3"
        >
          <template slot-scope="scope">
            <el-button
              @click="handleClick(scope.row)"
              type="text"
              size="small"
              >更改店铺信息</el-button
            >
            <el-button
              @click="distribution(scope.row)"
              type="text"
              size="small"
              >分配</el-button
            >
            <el-button @click="Delete(scope.row)" type="text" size="small" style="color: red"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <div class="page">
        <el-pagination
          style="margin-right: 200px"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[50, 100, 200, 400]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>

    <el-dialog
      title="修改相关信息"
      :visible.sync="EditName"
      width="30%"
      style="margin-top: 20px"
    >
      <div>
        <label style="display: inline-block; width: 100px">名称：</label
        ><el-input
          placeholder="请输入要修改的店铺名称"
          v-model="NameValue1"
          style="margin-top: 10px; width: 70%"
        ></el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="EditName = false">取 消</el-button>
        <el-button type="primary" @click="Submit">提 交</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="新增TikTok授权"
      :visible.sync="AddName"
      width="30%"
      style="margin-top: 20px"
    >
      <div>
        <div>
          <label style="display: inline-block; width: 100px">店铺ID：</label
          ><el-input
            placeholder="请输入店铺ID"
            v-model="IDStore"
            style="margin-top: 10px; width: 70%"
          ></el-input>
        </div>
        <div>
          <label style="display: inline-block; width: 100px">店铺名称：</label
          ><el-input
            placeholder="请输入要修改的店铺名称"
            v-model="NameStore"
            style="margin-top: 10px; width: 70%"
          ></el-input>
        </div>
        <!-- <div style="margin-top:10px">
                    <label style="display: inline-block;width: 100px;">开户站：</label>
                    <el-select
                        v-model="country_mark"
                        placeholder="请选择"
                        @change="countryChange"
                    >
                        <el-option
                            v-for="item in selList"
                            :key="item.value"
                            :label="item.countryName"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </div> -->
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="AddName = false">取 消</el-button>
        <el-button type="primary" @click="SubmitSave">提 交</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="店铺分配"
      :visible.sync="shopDistribution"
      width="25%"
      style="margin-top: 20px"
    >
      <el-form class="custom-form" ref="form" label-width="100px" label="left">
        <el-form-item label="选择部门">
          <el-select v-model="value1" @change="choose1" placeholder="请选择">
            <el-option
              v-for="item1 in this.arr1"
              :key="item1.value"
              :label="item1.departmentName"
              :value="item1"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择分部门" v-show="isShow">
          <el-select v-model="value2" @change="choose2" placeholder="请选择">
            <el-option
              v-for="item2 in this.arr2"
              :key="item2.value"
              :label="item2.departmentName"
              :value="item2"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择组" v-show="isShow">
          <el-select v-model="value3" @change="choose3" placeholder="请选择">
            <el-option
              v-for="item3 in this.arr3"
              :key="item3.value"
              :label="item3.groupName"
              :value="item3"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择员工">
          <el-select v-model="value4" @change="choose4" placeholder="请选择">
            <el-option
              v-for="item4 in this.arr4"
              :key="item4.value"
              :label="item4.roleName"
              :value="item4"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="shopDistribution = false">取消</el-button>
        <el-button type="primary" @click="Submit1" :loading="loadingStatus"
          >分配</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ajaxGet, ajaxPost, Baseurl } from "../../api/api/api";
import { AmazonPost } from "../../api/api/api";
import { mapState } from 'vuex';
export default {
  name: "TikTokAuthorize",
  components: {},
  props: {},
  data() {
    return {
      active: "",
      isDisabled: true,
      // shopeeAccountId: false,
      // shopID: false,
      NameValue2: "",
      amazon_id2: "",
      EditName: false,
      AddName: false,
      currentPage: 1,
      pagesize: 50,
      size: 50,
      total: 0,
      state: '',
      tableData: [],
      countryLink1: "",
      countryCode: "",
      SearchInp: "",
      branchCompany: [],
      sonCompany: [],
      branchDepartmentList: [],
      groupList: [],
      userList: [],
      arr1: "",
      arr2: "",
      arr3: "",
      arr4: "",
      value1: "",
      value2: "",
      value3: "",
      value4: "",
      loadingTable: false,
      shopDistribution: false,
      loadingStatus: false,
      sid: "",
      gid: "",
      rid: "",
      isShow: true,
      formScreen: {
        branchCompany: {},
        sonCompany: {},
        departmentValue: {},
        branchDepartmentValue: {},
        groupValue: {},
        userValue: {},
      },
      sellerId1: "",
      NameValue1: "",
      NameStore: "",
      IDStore: "",
      mwsAuthTokenValue1: "",
      developerId: "",
      companyId: "",
      staffId: "",
      System: "",
      type: "",
      refresh_token: "",
      access_token: "",
      country_mark: "",
      selList: "",
      merchant_id_list: [],
      shop_id_list: [],
      exchangeLoading: false,
      region: '',
    };
  },
  computed: {
    ...mapState({
      role: state => state.user.role,
    })
  },
  watch: {
    role: {
      handler(newVal) {
        this.reset();
      },
      deep: true,
    },
  },
  created() {
    this.reset();
  },
  mounted() {
    // this.shopID = window.localStorage.getItem("shopeeShopID")
    // this.shopeeAccountId = window.localStorage.getItem("shopeeAccountId")
    if (localStorage.getItem("TikTok_code")) {
      this.isDisabled = false;
    }
    // this.shopID = true
    // this.shopeeAccountId = true
    // let obj = window.localStorage.getItem('query')
    // console.log(JSON.parse(obj))
  },
  methods: {
    reset(){
      if (this.role === null) {
        return false;
      } else {
        this.type = this.role.type;
        this.init();
        this.tableList();
        this.selectList();
      }
    },
    handleTableSwitch(item) {
      const API = Baseurl + 'sellerController/updateSellerInfoActive'
      const paramsData = { 
        id: item.id,
        active: item.active
      }
      console.log(paramsData);
      // paramsData.id = item.id
      // paramsData.priority = item.priority

      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data
        if (code === 200) {
          this.$message.success('操作成功')
        } else {
          this.Search2()
          this.$message.error(data)
        }
      })
    },
    toTutorial() {
      window.open("https://hyxun-erp-image.oss-cn-hangzhou.aliyuncs.com/file/TikTok%E6%8E%88%E6%9D%83%E6%95%99%E7%A8%8B.pdf", "_blank")
    },
    countryChange(val) {
      this.country_mark = val;
    },
    selectList() {
      ajaxPost(Baseurl + "sellerController/getAllCountry").then((res) => {
        // console.log(res.data)
        const { code, data } = res.data;
        if (code === 200) {
          this.selList = data;
        }
      });
    },
    exchange() {
      let TikTok_code = window.localStorage.getItem("TikTok_code");
      if (TikTok_code) {
        const API = Baseurl + "tikTokOauth/getAccessToken"
        const paramsData = { code: TikTok_code }
        this.exchangeLoading = true
        ajaxPost(API, paramsData).then((res) => {
					window.localStorage.removeItem("TikTok_code")
          this.isDisabled = true
          this.exchangeLoading = false
          if (res.data.code === 200) {
            this.access_token = res.data.data.access_token
            this.refresh_token = res.data.data.refresh_token
            this.SubmitSave()
          } else {
            this.$message.error("交换失败")
          }
        })
      }
    },
    toAuthUrl() {
      // const API = Baseurl + "tikTokOauth/getOauthUrl";
      // ajaxGet(API).then((res) => {
      //   if (res.data.code === 200) {
      //     window.open(res.data.data, "_self");
      //   } else {
      //     this.$message.error(res.data.message);
      //   }
      // });
      if(!this.region){
        this.$message.error('请选择地域')
        return
      }
      let API = '';
      if(this.region === 'US'){
        API = Baseurl + 'tikTok2025Oauth/getUsOauthUrl'
      }else{
        API = Baseurl + 'tikTok2025Oauth/getOauthUrl'
      }
      ajaxGet(API).then(res => {
        if(res.data.code === 200){
          window.open(res.data.data, '_self')
        }else{
          this.$message.error(res.data.message)
        }
      })
    },
    selectChange(item, type) {
      const { rid, system, company_id: companyId } = item;
      companyId && (this.companyId = companyId);
      this.getNextPower(rid, system, type);
      if (type === "sonCompany") {
        this.formScreen.sonCompany = {};
        this.formScreen.departmentValue = {};
        this.formScreen.groupValue = {};
        this.sonCompany = [];
        this.departmentList = [];
        this.groupList = [];
      } else if (type === "departmentList") {
        this.formScreen.departmentValue = {};
        this.formScreen.branchDepartmentValue = {};
        this.formScreen.groupValue = {};
        this.departmentList = [];
        this.branchDepartmentList = [];
        this.groupList = [];
      } else if (type === "branchDepartmentList") {
        this.formScreen.branchDepartmentValue = {};
        this.formScreen.groupValue = {};
        this.branchDepartmentList = [];
        this.groupList = [];
      } else if (type === "groupList") {
        this.formScreen.groupValue = {};
        this.formScreen.userValue = {};
        this.groupList = [];
        this.userList = [];
      } else if (type === "userList") {
        this.formScreen.userValue = {};
        this.userList = [];
      }
      this.staffId = rid;
      this.System = system;
    },
    Submit1() {
      this.$confirm("是否分配该店铺当前时间之前的所有订单", "提示", {
        confirmButtonText: "是",
        cancelButtonText: "否",
        type: "warning",
      })
        .then(() => {
          this.isAccept = 1;
          this.submitAjax();
        })
        .catch(() => {
          this.isAccept = 0;
          this.submitAjax();
        });
    },
    submitAjax() {
      var obj = {
        departmentId: this.departmentId,
        departmentChildId: this.departmentChildId,
        gid: this.gid,
        rid: this.rid,
        sid: this.sid,
        isAccept: this.isAccept,
      };
      // console.log(obj);
      this.loadingStatus = true;
      ajaxPost(Baseurl + "sellerController/allotSeller", obj).then((res) => {
        this.loadingStatus = false;
        if (res.data.code == 200) {
          this.$message({
            message: "分配店铺成功",
            type: "success",
          });
          this.tableList();
          this.shopDistribution = false;
        } else {
          this.$message.error(res.data.data);
        }
      });
    },
    choose1(val) {
      this.departmentId = val.did;
      // console.log(val)
      this.arr2 = [];
      this.arr3 = [];
      this.arr4 = [];
      this.value2 = "";
      this.value3 = "";
      this.value4 = "";

      if (val.kind === 0) {
        this.isShow = true;
        var company_id = {
          dgrId: val.dgrId,
          system: 2,
        };
        ajaxPost(
          Baseurl + "roleController/selectNextInfoByDgrId",
          company_id
        ).then((res) => {
          const { code, data } = res.data;
          if (code === 200) {
            this.arr2 = res.data.data.next;
          }
        });
      } else if (val.kind === 1) {
        this.departmentChildId = "";
        this.gid = "";
        this.isShow = false;
        var company_id = {
          dgrId: val.dgrId,
          system: 2,
        };
        ajaxPost(
          Baseurl + "roleController/selectNextInfoByDgrId",
          company_id
        ).then((res) => {
          const { code, data } = res.data;
          if (code === 200) {
            this.arr4 = res.data.data.next;
          }
        });
      }
    },
    choose2(val) {
      this.departmentChildId = val.did;
      // console.log(val)
      this.arr3 = [];
      this.arr4 = [];
      this.value3 = "";
      this.value4 = "";
      var company_id = {
        dgrId: val.dgrId,
        system: 3,
      };
      ajaxPost(
        Baseurl + "roleController/selectNextInfoByDgrId",
        company_id
      ).then((res) => {
        const { code, data } = res.data;
        if (code === 200) {
          this.arr3 = res.data.data.next;
        }
      });
    },
    choose3(val) {
      this.gid = val.gid;
      // console.log(val)
      this.arr4 = [];
      this.value4 = "";
      var company_id = {
        dgrId: val.dgrId,
        system: 4,
      };
      ajaxPost(
        Baseurl + "roleController/selectNextInfoByDgrId",
        company_id
      ).then((res) => {
        const { code, data } = res.data;
        if (code === 200) {
          this.arr4 = res.data.data.next;
        }
      });
    },
    choose4(val) {
      this.rid = val.rid;
      // console.log(val)
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.size = val;
      this.tableList();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.tableList();
    },
    formScreenReset() {
      this.currentPage = 1;
      this.$refs.formScreen.resetFields();
      this.branchCompany = [];
      this.sonCompany = [];
      this.departmentList = [];
      this.branchDepartmentList = [];
      this.groupList = [];
      this.userList = [];
      this.SearchInp = "";
      this.state = '';
      this.staffId = this.role.rid;
      this.System = this.role.system;
      this.tableList();
      this.init();
    },
    init() {
      const {
        rid,
        system,
        company_id: companyId,
        type: companyType,
      } = this.role;
      this.companyId = companyId;
      this.staffId = rid;
      this.System = system;
      let type = "";
      if (companyType === 1) {
        type = "branchCompany";
      } else if (companyType === 2) {
        type = "sonCompany";
      } else if (system < 3) {
        type = "branchDepartmentList";
      } else if (system === 3) {
        type = "groupList";
      } else {
        return;
      }
      // this.tableList(type, companyId, rid, system)
      this.getNextPower(rid, system, type);
    },
    getNextPower(rid, system, type) {
      const API = Baseurl + "roleController/selectNextInfoByRid";
      const paramsData = {
        rid,
        system,
        companyId: this.companyId,
        sellerType: 12,
      };
      ajaxPost(API, paramsData)
        .then((res) => {
          const {
            data: { code, data },
          } = res;
          if (code === 200) {
            this[type] = data.next;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    tableList() {
      this.loadingTable = true;
      const paramsData = {
        isSpapiAuthorize: 0,
        sellerType: 12,
        page: this.currentPage,
        size: this.size,
        company_id: this.companyId,
        rid: this.staffId,
        system: this.System,
        searchString: this.SearchInp,
        active: this.active,
        state: this.state,
      };
      ajaxPost(
        Baseurl + "sellerController/selectSellerListByRid",
        paramsData
      ).then((res) => {
        const { code, data } = res.data;
        this.loadingTable = false;
        if (code === 200) {
          const {
            next = [],
            sellerInfo: { list, total },
          } = data;
          // list.map(item => {
          //   item.mainAccountIdList = []
          //   list.map(ele => {
          //     if (ele.mainAccountId === item.mainAccountId) {
          //       item.mainAccountIdList.push(ele.mainAccountId)
          //     }
          //   })
          // })
          // this[type] = next
          this.tableData = list;
          this.spanMethod()
          this.total = total;
          this.tableCountry = [];
          for (var i = 0; i < list.length; i++) {
            this.tableCountry.push(list[i].countryMarks);
          }
        }
        // console.log(this.tableData)
      });
    },
    spanMethod(data) {
      if (!data) return
      const num = data.row.mainAccountIdList.length === 0 ? 1 : data.row.mainAccountIdList.length
      const arr = [0]
      if (arr.includes(data.columnIndex)) {
        if (
          data.rowIndex > 0 &&
          data.row.mainAccountId === this.tableData[data.rowIndex - 1].mainAccountId
        ) {
          return {
            rowspan: 0,
            colspan: 0
          }
        } else {
          return {
            rowspan: num,
            colspan: 1
          }
        }
      }
    },
    Search2() {
      this.currentPage = 1;
      this.tableList();
    },
    Delete(item) {
      // console.log(item)
      this.$confirm("确认删除此条数据", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var obj = { id: item.id };
          ajaxPost(Baseurl + "sellerController/deleteSellerInfo", obj).then(
            (res) => {
              if (res.data.code == 200) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                this.tableList();
              } else {
                this.$message.error("删除失败");
              }
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    distribution(val) {
      // console.log(val)
      this.sid = val.id;
      this.shopDistribution = true;
      var company_id = {
        company_id: this.companyId,
        sellerType: 12,
      };
      ajaxPost(
        Baseurl + "roleController/selectDepartmentByCompanyId",
        company_id
      ).then((res) => {
        const { code, data } = res.data;
        if (code === 200) {
          this.arr1 = res.data.data;
        }
      });
    },
    handleClick(item) {
      this.EditName = true;
      // console.log(JSON.parse(JSON.stringify(item)))
      // item.countryMarks.area
      // IOSS
      // item.countryMarks.forEach((val) => {
      // 	if (val.area == 'EUR') {
      // 		this.IOSS = true
      // 	} else {
      // 		this.IOSS = false
      // 	}
      // })
      // this.iossCode = item.iossCode
      this.sellerId1 = item.sellerId;
      this.NameValue1 = item.shop_name;
      this.mwsAuthTokenValue1 = item.mwsAuthToken;
      this.developerId = item.developerId;
    },
    SubmitSave() {
      const API = Baseurl + "sellerController/insertTikTokSellerInfo";
      const paramsData = {
        company_id: this.companyId,
        refreshToken: this.refresh_token,
        accessToken: this.access_token,
      };
      ajaxPost(API, paramsData).then((res) => {
        if (res.data.code == 200) {
          this.$message.success("授权成功！");
          this.tableList();
        } else {
          this.$message({
            message: res.data.data,
            type: "error",
            duration: 2000,
          });
        }
      });
    },
    Submit() {
      // console.log()
      // return
      // if (this.IOSS) {
      // 	let str = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{12}$/
      // 	if (!str.test(this.iossCode)) {
      // 		this.$message.error('IOSS格式为12位字母+数字组合')
      // 		return
      // 	}
      // }

      var obj = {
        sellerId: this.sellerId1,
        shop_name: this.NameValue1,
        mwsAuthToken: this.mwsAuthTokenValue1,
        developerId: this.developerId,
        // iossCode: this.iossCode,
      };
      ajaxPost(Baseurl + "sellerController/updateShopNameBySellerId", obj).then(
        (res) => {
          // console.log(res.data)
          if (res.data.code == 200) {
            this.$message({
              message: "修改店铺名成功",
              type: "success",
            });
            this.tableList();
          } else {
            this.$message.error(res.data.data);
          }
        }
      );
      this.NameValue = "";
      this.EditName = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.AccreditTest {
  width: 98%;
  .el-button {
    padding: 9px 15px;
  }
  .el-table {
    margin-top: 20px;
  }
  .page {
    position: fixed;
    width: 100%;
    bottom: 0;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
  }
}
.green-text {
	color: #67c23a;
}

.red-text {
	color: #f56c6c;
}
</style>
